export default {
  locale: "en",
  name: "Partners",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [],
  },
};
